import styled, { css } from 'styled-components';
import tinycolor from 'tinycolor2';

import withLayout from '../../utils/styles/layout/withLayout';

type Props = {
  layout: any;
  circle?: boolean;
  disabled?: boolean;
  large?: boolean;
  small?: boolean;
};

const BasicButton = styled.button<Props>`
    width: 100%;
    padding: 10px 20px;
    border-radius: 4px;
    border: 1px solid ${({ layout }) => layout.borderColor || layout.backgroundColor};
    font-weight: 600;
    text-align: center;
    letter-spacing: 1px;
    cursor: pointer;
    overflow: hidden;

    ::after {
      opacity: 0;
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      transition: all ease-in-out 0.2s;
    }

    ${props =>
      !props.disabled &&
      css`
        &:hover {
          ::after {
            background-color: ${({ theme: { colors } }) => colors.light.primary};
            opacity: 0.3;
          }
        }
      `}
    ${props =>
      !props.disabled &&
      css`
        &:focus,
        &:active {
          ::after {
            background-color: ${({ theme: { colors } }) => colors.dark.primary};
            opacity: 0.3;
          }
        }
      `}
  ${props =>
    props.large &&
    css`
      padding: 16px 30px;
    `}
  ${props =>
    props.circle &&
    css`
      border-radius: 100px;
    `}

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}


  ${({ layout }) =>
    layout.backgroundColor &&
    `
    background-color: ${layout.backgroundColor};

    :active {
      background-color: ${({ layout }) =>
        tinycolor(layout.backgroundColor)
          .darken(5)
          .toString()};
    }
  `};

`;

export default withLayout(BasicButton);
